/** Corporate center M join flow (join/components/m) */
export default {
	common: {
		cancel: "Cancel",
		confirm: "OK",
		translate: "Translate",
	},
	stepBasic: {
		sectionBasic: "Basic information",
		sectionMedia: "Photos & video",
		sectionDetail: "About",
		sectionManager: "Manager",
		sectionService: "Services",
		orgName: "Institution name",
		orgNamePh: "Enter name",
		orgNameReq: "Name is required",
		orgNameEn: "English name",
		orgNameEnPh: "Enter English name",
		orgNameEnReq: "English name is required",
		category: "Category",
		categoryPh: "Select category",
		categoryReq: "Category is required",
		businessStatus: "Business status",
		businessStatusPh: "Select status",
		businessStatusReq: "Business status is required",
		businessHours: "Business hours",
		businessHoursReq: "Set business hours",
		contactPhone: "Phone",
		contactPhoneReq: "Add at least one phone",
		orgAddress: "Country / region",
		orgAddressPh: "Select",
		orgAddressReq: "Required",
		addressInfo: "Province / city / district",
		addressInfoPh: "Select",
		addressInfoReq: "Required",
		detailAddress: "Address",
		detailAddressPh: "Street, building, unit",
		detailAddressReq: "Address is required",
		addressEn: "Address (English)",
		addressEnPh: "Enter English address",
		addressEnReq: "English address is required",
		coordinates: "Coordinates",
		coordinatesPh: "Tap to fetch",
		coordinatesReq: "Coordinates required",
		getCoords: "Fetch",
		cover: "Profile image",
		coverReq: "Upload profile image",
		uploadCover: "Upload profile image",
		shopImages: "Photos",
		shopImagesReq: "Upload photos",
		uploadShopImages: "Upload photos",
		video: "Video",
		videoReq: "Upload video",
		uploadVideo: "Upload video",
		labelTraditional: "Traditional Chinese",
		descTraditionalReq: "Enter description",
		descTraditionalPh: "Enter description",
		labelEnglish: "English",
		descEnglishReq: "Enter English description",
		descEnglishPh: "Enter English description",
		editorLoading: "Loading…",
		managerAvatar: "Photo",
		managerAvatarReq: "Upload manager photo",
		uploadManagerAvatar: "Upload photo",
		managerDescZh: "Traditional Chinese",
		managerDescZhPh: "Introduction",
		managerDescZhReq: "Introduction is required",
		managerDescEn: "English",
		managerDescEnPh: "English introduction",
		managerDescEnReq: "English introduction is required",
		services: "Services",
		servicesReq: "Configure services",
		restore: "Restore",
		save: "Save",
		next: "Next",
		toastAddressFirst: "Complete address fields first",
		toastRestored: "Restored",
		toastSaved: "Saved",
	},
	stepQualification: {
		title: "Qualifications",
		orgName: "Institution name",
		orgNameEn: "English name",
		orgAddress: "Address",
		certificate: "Registration certificate",
		certificateReq: "Upload certificate",
		uploadImage: "Upload image",
		certificateTip: "Photograph the original certificate; text must be clear.",
		managerName: "Manager name",
		managerNamePh: "Enter name",
		managerNameReq: "Name is required",
		managerArea: "Region",
		managerAreaPh: "+852 Hong Kong",
		managerAreaReq: "Select region",
		managerPhone: "Manager mobile",
		managerPhonePh: "Enter mobile number",
		managerPhoneReq: "Mobile is required",
	},
	contactPhone: {
		addTitle: "Add phone",
		typeMobile: "Mobile",
		typeLandline: "Landline",
		header: "Add phone",
		chooseType: "Number type",
		enterMobile: "Mobile number",
		enterLandline: "Landline",
		areaCodePh: "Area code",
		landlinePh: "Number",
		extPh: "Extension (optional)",
		mobilePh: "Mobile number",
		regionPh: "+852 Hong Kong",
		toastMobile: "Enter mobile number",
		toastArea: "Enter area code",
		toastLandline: "Enter landline number",
	},
	businessHour: {
		add: "Add hours",
		modalTitle: "Add hours",
		selectDay: "Select day(s)",
		tipUsed: "Days already configured cannot be selected again.",
		selectTime: "Select time range",
		startPh: "Start time",
		endPh: "End time",
		to: "to",
		toastDay: "Select at least one day",
		toastTime: "Select time range",
		toastTimeOrder: "Start time must be before end time",
		hourSuffix: "h",
		minuteSuffix: "m",
		dayMon: "Mon",
		dayTue: "Tue",
		dayWed: "Wed",
		dayThu: "Thu",
		dayFri: "Fri",
		daySat: "Sat",
		daySun: "Sun",
	},
	videoUpload: {
		defaultUpload: "Upload video",
		defaultTip: "MP4, AVI, MOV, max 50MB",
		uploading: "Uploading…",
		processing: "Processing…",
		preparing: "Preparing…",
		uploadProgressPercent: "Uploading {p}%",
		uploadProgressLabel: "Progress",
		altCover: "Video cover",
		maxVideos: "You can upload at most {n} videos",
		needVideo: "Please choose a video file",
		maxSize: "Video must be 50MB or smaller",
		processFail: "Could not process file",
		uploadOk: "Uploaded",
		uploadFail: "Upload failed",
		removed: "Video removed",
	},
	uploadMedia: {
		altImage: "Image",
		cropTitle: "Crop image",
		cropUnavailable: "Crop is unavailable",
		directUpload: "Upload without crop",
		loadingImage: "Loading image…",
		cropTips: "Pinch to zoom, drag to move",
		confirmUpload: "Crop & upload",
		defaultText: "Upload",
		maxFiles: "At most {n} files",
		pickImageOrVideo: "Choose an image or video",
		pickImage: "Choose an image",
		pickVideo: "Choose a video",
		imageTooBig: "Image must be under 20MB",
		readFail: "Could not read image",
		formatUnsupported: "Unsupported image format",
		readFailMsg: "Read failed: {msg}",
		readCancelled: "Cancelled",
		cannotRead: "Cannot read file",
		noUrl: "Upload failed: no file URL",
		uploadOk: "Uploaded",
		loadFailDirect: "Load failed — try direct upload",
		fileMissing: "File missing",
		processFail: "Processing failed",
		cropFail: "Crop failed",
		imageNotLoaded: "Image not loaded",
		cropUnavailableToast: "Crop unavailable — use direct upload",
		loadFail: "Load failed",
		cropOpFail: "Crop failed",
		unknownError: "Unknown error",
		uploadFail: "Upload failed",
		cropperNotInit: "Cropper not ready",
	},
	serviceModal: {
		add: "Add service",
		edit: "Edit service",
		addTitle: "Add service",
		image: "Image",
		imageReq: "Upload image",
		uploadImage: "Upload image",
		name: "Name",
		namePh: "Service name",
		nameReq: "Name is required",
		nameEn: "Name (English)",
		nameEnPh: "English name",
		nameEnReq: "English name is required",
		intro: "Summary",
		introPh: "Summary",
		introReq: "Summary is required",
		introEn: "Summary (English)",
		introEnPh: "English summary",
		introEnReq: "English summary is required",
		detailZh: "Details (TC)",
		detailZhPh: "Details",
		detailZhReq: "Details (Traditional Chinese) required",
		detailEn: "Details (EN)",
		detailEnPh: "Details",
		detailEnReq: "Details (English) required",
		price: "Price (USD)",
		pricePh: "USD, minimum 1",
		priceReq: "Price (USD) required",
		priceInvalid: "Enter a valid price",
		priceUsdInvalid: "Enter a valid USD price",
		deleting: "Deleting…",
		deleted: "Service deleted",
		deleteFail: "Delete failed, try again",
		removed: "Service removed",
		saving: "Saving…",
		updated: "Service updated",
		created: "Service created",
		opFail: "Operation failed, try again",
	},
	header: {
		logoText: "SeerQ · Partner center",
		logout: "Log out",
		nicknameFallback: "Nickname",
		langHintZh: "Switch to English",
		langHintEn: "Switch to Traditional Chinese",
	},
	stepWaiting: {
		title: "Submitted",
		body: "Your application is under review and cannot be edited during this period. We will respond within 3–10 business days. Results will be sent to your registered phone or email.",
		return: "Back",
	},
};
